import { MODEL_KEY } from '../../../model'

const EXERCISE_LOG_SUMMARY_CLASS_NAME = 'ExerciseLogSummary'

const EXERCISE_LOG_SUMMARY_KEY = {
  ...MODEL_KEY,

  EXERCISE_LOGS_COUNT: 'exerciseLogsCount',
  SET_COUNT: 'setCount',

  FIRST_TRAINING_VOLUME: 'firstTrainingVolume',
  MIN_TRAINING_VOLUME: 'minTrainingVolume',
  AVERAGE_TRAINING_VOLUME: 'averageTrainingVolume',
  MAX_TRAINING_VOLUME: 'maxTrainingVolume',
  TOTAL_TRAINING_VOLUME: 'totalTrainingVolume',
  LAST_TRAINING_VOLUME: 'lastTrainingVolume',

  FIRST_DURATION: 'firstDuration',
  LAST_DURATION: 'lastDuration',
  MIN_DURATION: 'minDuration',
  AVERAGE_DURATION: 'averageDuration',
  MAX_DURATION: 'maxDuration',
  TOTAL_DURATION: 'totalDuration',

  FIRST_REST: 'firstRest',
  LAST_REST: 'lastRest',
  MIN_REST: 'minRest',
  AVERAGE_REST: 'averageRest',
  MAX_REST: 'maxRest',
  TOTAL_REST: 'totalRest',

  FIRST_WEIGHT: 'firstWeight',
  LAST_WEIGHT: 'lastWeight',
  MIN_WEIGHT: 'minWeight',
  MIN_WEIGHT_DURATION: 'minWeightDuration',
  AVERAGE_WEIGHT: 'averageWeight',
  MAX_WEIGHT: 'maxWeight',
  MAX_WEIGHT_DURATION: 'maxWeightDuration',
  TOTAL_WEIGHT: 'totalWeight',

  ONE_REP_MAX: 'oneRepMax',
  ESTIMATED_ONE_REP_MAX: 'estimatedOneRepMax',

  AVERAGE_REPS: 'averageReps',
  FIRST_REPS: 'firstReps',
  LAST_REPS: 'lastReps',
  MIN_REPS: 'minReps',
  MAX_REPS: 'maxReps',
  MIN_WEIGHT_REPS: 'minWeightReps',
  MAX_WEIGHT_REPS: 'maxWeightReps',
  TOTAL_REPS: 'totalReps',

  // Associations
  EXERCISE: 'exercise',
  EXERCISE_LOGS: 'exerciseLogs',

  // Foreign keys
  EXERCISE_ID: 'exerciseId',
  PROFILE_ID: 'profileId'
}

const EXERCISE_LOG_SUMMARY_PRIVATE_KEYS = []
const EXERCISE_LOG_SUMMARY_FOREIGN_KEYS = [
  EXERCISE_LOG_SUMMARY_KEY.EXERCISE_ID,
  EXERCISE_LOG_SUMMARY_KEY.PROFILE_ID
]
const EXERCISE_LOG_SUMMARY_ASSOCIATIONS = [
  EXERCISE_LOG_SUMMARY_KEY.EXERCISE,
  EXERCISE_LOG_SUMMARY_KEY.EXERCISE_LOGS
]

const EXERCISE_LOG_SUMMARY_SCOPE = {

  /**
   * Only returns the public attributes.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: EXERCISE_LOG_SUMMARY_PRIVATE_KEYS
    }
  }

}

export {
  EXERCISE_LOG_SUMMARY_CLASS_NAME,
  EXERCISE_LOG_SUMMARY_KEY,
  EXERCISE_LOG_SUMMARY_PRIVATE_KEYS,
  EXERCISE_LOG_SUMMARY_FOREIGN_KEYS,
  EXERCISE_LOG_SUMMARY_ASSOCIATIONS,
  EXERCISE_LOG_SUMMARY_SCOPE
}
